import { apiClient, getToken, getOrgId } from '@devd-client/api';

export const getAllRepos = (source: string): Promise<any> =>
  apiClient(
    `/v1/integration/${source}/org/${getOrgId()}/projects/lite?active=true`,
    {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );
